import React, { useEffect, useState } from 'react'
import styles from "./ResubmitSuccess.styles";
import Button from '../../../../../components/button/Button';
import BasicCard from '../../../../../components/card/basiccard/BasicCard';
import Heading from '../../../../../components/heading/Heading';
import { HEADING } from '../../../../../components/heading/constants/constants';
import useTxNavigate from '../../../../../../libs/txnavigate/TxNavigateHook';
import { FORM_SECTION_ROUTES, QUERY_PARAMS } from '../../../constants';
import useTxSearchParams from '../../../../../../libs/txsearchparams/TxSearchParamsHook';

export default function ResubmitSuccess() {
    const [referenceId, setReferenceId] = useState(null);
    const [queryParams] = useTxSearchParams();
    const navigate = useTxNavigate();

    useEffect(() => {
        setReferenceId(queryParams.get(QUERY_PARAMS.REFERENCE_ID))
    }, [])

    return (
        <>
            <Heading type={HEADING.H1} customStyle={styles.header}>Prepay Payment Confirmation</Heading>

            <BasicCard>
                <div>
                    <p>Your return has been scheduled for submission to the IRS. We will email you the status of the return after IRS processes it. You can see your complete filing history here.</p>
                    <p>Forms emailed to recipients will be sent within 24 hours. You can check the status on the Dashboard under Email Status within 24 hours to see if they have been sent, opened, or rejected for an incorrect email address.</p>
                    <p>Forms mailed to recipients will be sent within 24-48 business hours and should arrive via USPS mail 3-5 business days after that.</p>
                    {referenceId && <p>Reference Number: {referenceId}</p>}
                    <p>Thanks for using the Tax1099.com service.</p>
                </div>
                <Button style={styles.okButton} onClickCb={() => navigate(`/${FORM_SECTION_ROUTES.FORMS}/${FORM_SECTION_ROUTES.LISTING}`)}>Click here to submit more records</Button>
            </BasicCard>

        </>
    )
}
